import { defineComponent  } from './vue.esm-browser.prod.js';


export default defineComponent({
  props: {
    options: { type: Array, required: true },
    selectedOption: { type: Object, required: true },
  },

  // @ts-ignore
  setup(props, { emit }) {  
  
    function handleSelectedOptionClick(/** @type {Option} option */ option) {
      emit('select-option-click', option);
    }


    return { handleSelectedOptionClick };
  },

  template: /* html */`
    <div class="VariantPills">
      <div
        v-for="option in options"
        :key="option.value"
        :option="option"
        class="VariantPills__option"
        :class="{ selected: selectedOption.value === option.value }"
        @click="handleSelectedOptionClick(option)"
      >
        {{ option.text[0] }}
      </div>
    </div>
  `,
});